import React from "react";
import ReactDOM from "react-dom/client";
import Bugsnag, { Client } from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { GqlClient } from "./GqlClient";
import { REACT_APP_GIT_HASH } from "./env";
import { Login, loginContext } from "./containers/Login";
import "../../components/tailwind.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { UnicornFallback } from "./UnicornFallback";

console.log("REACT_APP_GIT_HASH", REACT_APP_GIT_HASH);

let _bugsnagClient: Client | null = null;

// GDPR-compliant Bugsnag initialization
if (REACT_APP_GIT_HASH !== "dev") {
    _bugsnagClient = Bugsnag.start({
        apiKey: "5f3ece5377a7532c073d477be803299b",
        plugins: [new BugsnagPluginReact()],
        trackInlineScripts: false,
        collectUserIp: false,
        releaseStage: REACT_APP_GIT_HASH,
        appVersion: REACT_APP_GIT_HASH,
        enabledBreadcrumbTypes: []
    });
} else {
    _bugsnagClient = Bugsnag.start({
        apiKey: "5f3ece5377a7532c073d477be803299b",
        plugins: [new BugsnagPluginReact()],
        trackInlineScripts: false,
        enabledReleaseStages: [],
        collectUserIp: false,
        releaseStage: REACT_APP_GIT_HASH,
        appVersion: REACT_APP_GIT_HASH,
        enabledBreadcrumbTypes: []
    });
}

// Create Bugsnag ErrorBoundary component
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

// Authenticated Component
const Authenticated = (): React.ReactElement => (
    <Login>
        <loginContext.Consumer>{() => <GqlClient />}</loginContext.Consumer>
    </Login>
);

// Render Application Root with Wouter Router
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <ErrorBoundary FallbackComponent={UnicornFallback}>
            <div className="app">
                <Authenticated />
            </div>
        </ErrorBoundary>
    </React.StrictMode>
);
